export class OTA_RateRange {
    public currencyCode: string;
}
